import { useState } from 'react';
import { useT } from '../i18n';
import type { Role } from '../game/types';

const KEY = 'neonfall.coach';

type TipKey = 'goal' | 'play' | 'discard';

function loadSeen(): Partial<Record<TipKey, boolean>> {
  try {
    return JSON.parse(localStorage.getItem(KEY) ?? '{}');
  } catch {
    return {};
  }
}

/**
 * First-game coach: three one-time tips shown on the table — your goal (by
 * role), what to do on your first play phase, and the discard rule. Each is
 * dismissed once and remembered in localStorage; veterans never see them again.
 * Pure presentation — no game logic, mirrors what the reducer already enforces.
 */
export function Coach({
  phase,
  isMyTurn,
  myRole,
}: {
  phase: string;
  isMyTurn: boolean;
  myRole: Role | null;
}) {
  const t = useT();
  const [seen, setSeen] = useState(loadSeen);

  const active: TipKey | null =
    !seen.goal && myRole
      ? 'goal'
      : !seen.play && phase === 'play' && isMyTurn
        ? 'play'
        : !seen.discard && phase === 'discard' && isMyTurn
          ? 'discard'
          : null;

  if (!active) return null;
  const text = active === 'goal' ? t.coach.goal[myRole!] : t.coach[active];

  return (
    <div className="coach-tip">
      <span className="coach-text">{text}</span>
      <button
        className="btn small cyan"
        onClick={() => {
          const next = { ...seen, [active]: true };
          setSeen(next);
          localStorage.setItem(KEY, JSON.stringify(next));
        }}
      >
        {t.coach.gotIt}
      </button>
    </div>
  );
}
